<script lang="ts">
	import Action from '../action/Action.svelte'
	import Icon from '../icon/Icon.svelte'
	import Dropdown from './Dropdown.svelte'
	import DropdownBox from './DropdownBox.svelte'
	import { DropdownPosition } from './DropdownPosition'
	import { ChevronDown } from '@steeze-ui/heroicons'
	import { type Snippet } from 'svelte'

	interface Props {
		closeOnClickInside?: boolean
		position?: DropdownPosition
		name?: string | null
		portal?: boolean
		opened?: boolean
		placeholder?: Snippet
		children?: Snippet
		maxWidth?: number
	}

	let {
		closeOnClickInside = false,
		position = DropdownPosition.Right,
		name = null,
		portal = false,
		opened = $bindable(false),
		placeholder,
		children,
		maxWidth = 240,
	}: Props = $props()

	const placeholder_render = $derived(placeholder)
</script>

<div class="relative {opened ? 'z-20' : ''}">
	<Dropdown {closeOnClickInside} {maxWidth} {portal} bind:opened>
		{#snippet placeholder({ onclick })}
			<Action {name} {onclick}>
				<div class="flex cursor-pointer items-center">
					{@render placeholder_render?.()}
					<div class="ml-1"></div>

					<Icon class="dark:text-white {opened ? 'rotate-180' : ''}" small src={ChevronDown} />
				</div>
			</Action>
		{/snippet}
		<DropdownBox {portal} {position}>
			{@render children?.()}
		</DropdownBox>
	</Dropdown>
</div>
